// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateGeneralDateFormat = (key, list) =>
    dispatch => {

        dispatch({
            data: false,
            type: actions.UPDATE_USER_PREFERENCES_IS_SAVED
        });

        dispatch({
            dateFormat: list.find(item => item.key === key),
            type: actions.UPDATE_USER_PREFERENCES_GENERAL_DATE_FORMAT
        });

    };

export const updateGeneralDecimalFormat = (key, list) =>
    dispatch => {

        dispatch({
            data: false,
            type: actions.UPDATE_USER_PREFERENCES_IS_SAVED
        });

        dispatch({
            decimalFormat: list.find(item => item.key === key),
            type: actions.UPDATE_USER_PREFERENCES_GENERAL_DECIMAL_FORMAT
        });

    };

export const updateGeneralTimeZone = (key, list) =>
    dispatch => {

        dispatch({
            data: false,
            type: actions.UPDATE_USER_PREFERENCES_IS_SAVED
        });

        dispatch({
            timeZone: list.find(item => item.key === key),
            type: actions.UPDATE_USER_PREFERENCES_GENERAL_TIME_ZONE
        });

    };

export const updateCsvSeparator = (key, list) =>
    dispatch => {

        dispatch({
            data: false,
            type: actions.UPDATE_USER_PREFERENCES_IS_SAVED
        });

        dispatch({
            csvSeparator: list.find(item => item.key === key),
            type: actions.UPDATE_USER_PREFERENCES_CSV_SEPARATOR
        });

    };



// WEBPACK FOOTER //
// ./src/user/shared/action-creators/general-settings.js